
import { forwardRef, HTMLAttributes } from 'react';

const fullBleed = { width: '100%', gridColumn: '1 / 4 !important' };

type Props = {
  width: number | string;
} & HTMLAttributes<HTMLDivElement>;

const Container = forwardRef<HTMLDivElement, Props>(
  ({ children, width, ...props }, ref) => {
    return (
      <section
        ref={ref}
        css={{
          display: 'grid',
          gridTemplateColumns: `1fr min(${
            typeof width === 'number' ? `${width}px` : width
          }, 90%) 1fr`,
          '& > *': {
            gridColumn: 2,
          },
        }}
        {...props}
      >
        {children}
      </section>
    );
  }
);

export const FullBleedSection = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(({ children, ...props }, ref) => {
  return (
    <section ref={ref} {...props} css={fullBleed}>
      {children}
    </section>
  );
});

export default Container;
